import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const NorthMacedoniaFlagIcon: FC<PropsWithChildren<Props>> = ({
	className,
}) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15519'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15519)'>
				<rect
					width='20'
					height='14'
					fill='#E81B26'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.0001 9.33329C11.3151 9.33329 12.381 8.28862 12.381 6.99996C12.381 5.71129 11.3151 4.66663 10.0001 4.66663C8.68513 4.66663 7.61914 5.71129 7.61914 6.99996C7.61914 8.28862 8.68513 9.33329 10.0001 9.33329Z'
					fill='#FFE94F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M7.29234 5.0955C7.43613 4.89945 7.60154 4.71965 7.78514 4.55945L1.40204 -2.47144L-0.509766 -0.39063L7.29234 5.0955ZM7.78514 9.44058C7.60154 9.28038 7.43613 9.10058 7.29234 8.90453L-0.509766 14.3907L1.40204 16.4715L7.78514 9.44058ZM6.7006 7.46205C6.6788 7.31111 6.66752 7.15685 6.66752 7.00001C6.66752 6.84317 6.6788 6.68892 6.7006 6.53798L0.000854433 5.60001V8.40001L6.7006 7.46205ZM10.6547 10.2039C10.4433 10.2451 10.2246 10.2667 10.0009 10.2667C9.77707 10.2667 9.55844 10.2451 9.34701 10.2039L8.57228 14H11.4294L10.6547 10.2039ZM10.6547 3.79617L11.4294 1.28746e-05H8.57228L9.34701 3.79617C9.55844 3.75496 9.77707 3.73335 10.0009 3.73335C10.2246 3.73335 10.4433 3.75496 10.6547 3.79617ZM13.3011 6.53798C13.3229 6.68892 13.3342 6.84317 13.3342 7.00001C13.3342 7.15685 13.3229 7.31111 13.3011 7.46205L20.0009 8.40001V5.60001L13.3011 6.53798ZM12.7094 8.90453C12.5656 9.10058 12.4002 9.28038 12.2166 9.44058L18.5997 16.4715L20.5115 14.3907L12.7094 8.90453ZM12.7094 5.0955C12.5656 4.89945 12.4002 4.71965 12.2166 4.55944L18.5997 -2.47144L20.5115 -0.39063L12.7094 5.0955Z'
					fill='#FFE94F'
				/>
			</g>
		</svg>
	);
};

export default NorthMacedoniaFlagIcon;
